import { createMultiStyleConfigHelpers as l, cssVar as i } from "@chakra-ui/react";
import { InputAnatomy as t } from "./Input.anatomy.es.js";
const { definePartsStyle: r, defineMultiStyleConfig: n } = l(
  t.keys
), e = i("input-bg"), d = r({
  control: {
    display: "inline-flex",
    flexDirection: "column",
    paddingY: 1
  },
  field: {
    width: "full",
    appearance: "none",
    flex: 1,
    alignSelf: "stretch",
    border: "none",
    outline: "none",
    fontSize: "lg",
    fontStyle: "normal",
    fontWeight: 400,
    background: "transparent",
    color: "primary.500",
    lineHeight: "3.5"
  },
  addon: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    color: "primary.300"
  },
  fieldWithLeftAddon: {
    paddingLeft: 2
  },
  fieldWithRightAddon: {
    paddingRight: 2
  },
  group: {
    [e.variable]: "colors.white",
    position: "relative",
    display: "inline-flex",
    width: "full",
    borderRadius: "100px",
    borderWidth: "1px",
    borderColor: "primary.100",
    background: e.reference,
    _disabled: {
      opacity: 0.5
    },
    _invalid: {
      borderColor: "error.300",
      color: "error.500",
      _hover: {
        borderColor: "error.300",
        color: "error.700",
        outlineColor: "primary.50",
        outlineStyle: "solid",
        outlineWidth: "4px"
      },
      _focusVisible: {
        color: "error.700",
        borderColor: "error.500",
        outlineColor: "error.50",
        outlineStyle: "solid",
        outlineWidth: "4px"
      }
    }
  },
  fieldWithSmartData: {
    borderColor: "tertiary.500",
    backgroundColor: "tertiary.50"
  },
  smartAnimation: {
    display: "flex",
    flexWrap: "wrap"
  }
}), o = i("group-height"), a = {
  xl: r({
    addon: {
      minWidth: 8
    },
    group: {
      [o.variable]: "sizes.12",
      height: o.reference
    },
    field: {
      paddingLeft: 5,
      paddingRight: 5,
      height: `calc(${o.reference} - 2px)`
    },
    leftAddon: {
      paddingLeft: 2
    },
    rightAddon: {
      paddingRight: 2
    }
  }),
  lg: r({
    addon: {
      minWidth: 8
    },
    group: {
      [o.variable]: "sizes.10",
      height: o.reference
    },
    field: {
      paddingLeft: 4,
      paddingRight: 4,
      height: `calc(${o.reference} - 2px)`
    },
    leftAddon: {
      paddingLeft: 1
    },
    rightAddon: {
      paddingRight: 1
    }
  })
}, s = {
  primary: r({
    group: {
      _groupHover: {
        borderColor: "primary.300",
        outlineColor: "primary.50",
        outlineStyle: "solid",
        outlineWidth: "4px"
      },
      _groupFocusWithin: {
        borderColor: "secondary.500",
        outlineColor: "secondary.50",
        outlineStyle: "solid",
        outlineWidth: "4px"
      }
    },
    field: {
      _placeholder: {
        color: "primary.300"
      }
    }
  }),
  success: r({
    group: {
      borderColor: "success.300",
      color: "success.500",
      _groupHover: {
        borderColor: "success.300",
        color: "success.700",
        outlineColor: "primary.50",
        outlineStyle: "solid",
        outlineWidth: "4px"
      },
      _groupFocusWithin: {
        color: "success.700",
        borderColor: "success.500",
        outlineColor: "success.50",
        outlineStyle: "solid",
        outlineWidth: "4px"
      }
    }
  }),
  error: r({
    group: {
      borderColor: "error.300",
      color: "error.500",
      _groupHover: {
        borderColor: "error.300",
        color: "error.700",
        outlineColor: "primary.50",
        outlineStyle: "solid",
        outlineWidth: "4px"
      },
      _groupFocusWithin: {
        color: "error.700",
        borderColor: "error.500",
        outlineColor: "error.50",
        outlineStyle: "solid",
        outlineWidth: "4px"
      }
    }
  })
}, u = n({
  baseStyle: d,
  variants: s,
  sizes: a,
  defaultProps: {
    size: "lg",
    variant: "primary"
  }
});
export {
  u as Input
};
//# sourceMappingURL=Input.es.js.map
